<template>
  <div class="user-wrapper">
    <div class="content-box">
      <a v-if="questionLink" :href="questionLink" target="_blank">
        <span class="action">
          <a-icon type="question-circle-o"></a-icon>
        </span>
      </a>
      <!-- <notice-icon class="action"/> -->
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <a-avatar class="avatar" size="small" :src="avatar()"/>
          <span>{{ nickname() }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <a-menu-item key="0" @click="goToUserCenter">
            <!-- <router-link :to="{ name: 'center' }"> -->
            <a-icon type="user"/>
            <span>个人中心</span>
            <!-- </router-link> -->
          </a-menu-item>
          <a-menu-divider/>
          <a-menu-item key="3">
            <a href="javascript:;" @click="handleLogout">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import confirm from 'ant-design-vue/es/modal/confirm';
import { mapGetters } from 'vuex';
import mapAccout from '@/libs/MapAccount';

export default {
  name: 'UserMenu',
  props: {
    questionLink: {
      type: String,
      default: '',
    },
  },
  methods: {
    ...mapGetters(['nickname', 'avatar']),
    goToUserCenter() {
      mapAccout.jumpUserCenter();
    },
    handleLogout() {
      confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk: () => {
          this.$emit('logout');
        },
        onCancel() {
        },
      });
    },
  },
};
</script>
